import React from 'react';
import SummaryStats from './SummaryStats';
import AdvancedMetrics from './AdvancedMetrics';
import LapDetailsSection from './LapDetailsSection';

const Results = ({ results }) => {
    return (
        <div className="results">
            <h2>Analysis Results</h2>
            <SummaryStats 
                laps={results.laps}
                totalTime={results.totalTime}
                averageLapTime={results.averageLapTime}
                trackPoints={results.trackPoints}
            />
            <AdvancedMetrics 
                lapDetails={results.lapDetails}
                allLapDetails={results.allLapDetails}
            />
            <LapDetailsSection lapDetails={results.lapDetails} />
        </div>
    );
};

export default Results;